// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const NO_FOUC_SCRIPT = registerClientReference(
    function() { throw new Error("Attempted to call NO_FOUC_SCRIPT() from the server but NO_FOUC_SCRIPT is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/theme-provider.tsx <module evaluation>",
    "NO_FOUC_SCRIPT",
);
export const ThemeProvider = registerClientReference(
    function() { throw new Error("Attempted to call ThemeProvider() from the server but ThemeProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/theme-provider.tsx <module evaluation>",
    "ThemeProvider",
);
export const useTheme = registerClientReference(
    function() { throw new Error("Attempted to call useTheme() from the server but useTheme is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/theme-provider.tsx <module evaluation>",
    "useTheme",
);
